import api from './axiosInstance';
import { API_BASE_URL } from '../config';

const PROMPT_VARIANT_URL = `${API_BASE_URL}/PromptVariant`;

/**
 * Obtiene todas las variantes de prompts
 * @param {AbortSignal} signal
 * @returns {Promise<Array>}
 */
export const getPromptVariants = async (signal) => {
  try {
    const response = await api.get(PROMPT_VARIANT_URL, { signal });
    return response.data;
  } catch (error) {
    console.error('Error fetching prompt variants:', error);
    throw error;
  }
};

/**
 * Obtiene una variante de prompt por ID
 * @param {number|string} variantId
 * @param {AbortSignal} signal
 * @returns {Promise<Object>}
 */
export const getPromptVariantById = async (variantId, signal) => {
  try {
    const response = await api.get(`${PROMPT_VARIANT_URL}/${variantId}`, {
      signal,
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching prompt variant by id:', error);
    throw error;
  }
};

/**
 * Crea una nueva variante de prompt
 * @param {Object} payload - { name, customInstructions, variablesConfig }
 * @returns {Promise<Object>}
 */
export const createPromptVariant = async (payload) => {
  try {
    const response = await api.post(PROMPT_VARIANT_URL, {
      name: payload.name,
      customInstructions: payload.customInstructions,
      variablesConfig: payload.variablesConfig || null,
    });
    return response.data;
  } catch (error) {
    console.error('Error creating prompt variant:', error);
    throw error;
  }
};

/**
 * Actualiza una variante de prompt existente
 * @param {Object} payload - { id, name, customInstructions, variablesConfig }
 * @returns {Promise<Object>}
 */
export const updatePromptVariant = async (payload) => {
  try {
    const response = await api.put(`${PROMPT_VARIANT_URL}/${payload.id}`, {
      id: payload.id,
      name: payload.name,
      customInstructions: payload.customInstructions,
      variablesConfig: payload.variablesConfig || null,
    });
    return response.data;
  } catch (error) {
    console.error('Error updating prompt variant:', error);
    throw error;
  }
};

/**
 * Elimina una variante de prompt
 * @param {number|string} variantId
 * @returns {Promise<Object>}
 */
export const deletePromptVariant = async (variantId) => {
  try {
    const response = await api.delete(`${PROMPT_VARIANT_URL}/${variantId}`);
    return response.data;
  } catch (error) {
    console.error('Error deleting prompt variant:', error);
    throw error;
  }
};

/**
 * Ejecuta una variante de prompt (preview / test call)
 * @param {Object} payload - { variantId, variables }
 * @param {AbortSignal} signal
 * @returns {Promise<Object>}
 */
export const executePromptVariant = async (payload, signal) => {
  try {
    const response = await api.post(
      `${PROMPT_VARIANT_URL}/execute`,
      {
        variantId: payload.variantId,
        variables: payload.variables || {},
      },
      { signal }
    );
    return response.data;
  } catch (error) {
    console.error('Error executing prompt variant:', error);
    throw error;
  }
};
